import { initializeGraphicAssets } from '@ardoq/icons';
import { initializeLogging } from 'logging/logging';
import { initializeLocale } from 'utils/localeUtils';

export const initializeArdoqPackages = (): void => {
  initializeLogging();
  initializeLocale();
  initializeGraphicAssets();
};
